import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/sundaytowers.am/httpdocs-new/sundaytowers-front/src/modules/blog/template.js");
